import moment from 'moment';
import React, { useMemo } from 'react';
import { DATE_LONG_FORMAT, DATE_LONG_FORMAT_WITH_YEAR } from '../../../../data/constants/datetime';
import Tab from '../Tab';
import Tabs from '../Tabs';

function DateTabs(props) {
    const { className = '', value, onChange, dates = [] } = props,
        hasDifferentYears = useMemo(() => {
            const firstYear = moment(dates[0]).year();
            return dates.some((d) => moment(d).year() !== firstYear);
        }, [dates]),
        visibleFormat = hasDifferentYears ? DATE_LONG_FORMAT_WITH_YEAR : DATE_LONG_FORMAT;

    if (!dates.length) return null;

    return (
        <Tabs className={className} visibleTabs={3} arrows centerIndex={dates.indexOf(value)}>
            {dates.map((date, i) => (
                <Tab key={i} selected={date === value} onClick={() => onChange(date)}>
                    {moment(date).format(visibleFormat)}
                </Tab>
            ))}
        </Tabs>
    );
}

export default DateTabs;
